
import { type RASNFamily } from 'types'

import { mainSplitApi } from './redux/mainSplitApi'

export const rasnFamilyApi = mainSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    loadFamilyRasn: builder.mutation<RASNFamily, string>({
      query: (rasnFamilyId) => {
        return {
          url: `/rasn-families/${rasnFamilyId}/load`,
          method: 'GET'
        }
      }
    }),

    getFamilyRasnProcessedQuantity: builder.query<RASNFamily, string>({
      query: (rasnFamily) => {
        return {
          url: `/rasn-families/${rasnFamily}`,
          method: 'GET'
        }
      }
    })
  }),

  overrideExisting: false
})

export const { useLoadFamilyRasnMutation, useLazyGetFamilyRasnProcessedQuantityQuery } = rasnFamilyApi
